export default function CsHome() {
  return (
    <h2>Cs Home</h2>
  );
}
